import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { format } from 'date-fns'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)

const TIMEZONE = 'America/Costa_Rica'

export const convertToGMTMinus6 = (date: Date | string | undefined): string | undefined => {
	if (!date) return undefined
	const gmt6Time = dayjs(date).utc().tz(TIMEZONE)
	return gmt6Time.format('YYYY-MM-DDTHH:mm:ss')
}

// 🕓 Convierte a string local simple con date-fns
export const convertToLocalTimeString = (date: Date | undefined): string | undefined => {
	if (date) {
		return format(date, "yyyy-MM-dd'T'HH:mm:ss")
	}
	return undefined
}

// 🧾 Convierte a ISO con dayjs
export const customISOString = (date: Date | undefined): string | undefined => {
	if (date) {
		return dayjs(date).format('YYYY-MM-DDTHH:mm:ss')
	}
	return undefined
}

export const getDateInUTCMinus6 = (): Date => {
  const now = new Date();
  const localTime = now.getTime();
  const localOffsetMs = now.getTimezoneOffset() * 60 * 1000;

  const targetOffsetMs = 360 * 60 * 1000;

  const adjustedTime = localTime + localOffsetMs - targetOffsetMs;
  return new Date(adjustedTime);
};

export const formatDate = (
  date: string | Date | null,
  separator: '-' | '/' = '-',
  withTime = false,
  withSeconds = false,
  subtractSixHours = false,
  hoursOffset: number = 6
): string => {
  if (!date) return '';

  let d: dayjs.Dayjs;

  // 1) Si recibes directamente un Date, úsalo.
  if (date instanceof Date) {
    d = dayjs(date);
  } else {
    // 2) ISO 8601 (2025-06-25T…)
    if (/^\d{4}-\d{2}-\d{2}T/.test(date)) {
      d = dayjs.utc(date);
    } else {
      // 3) Formatos propios (estrictos)
      d = dayjs(
        date,
        [
          'DD/MM/YYYY HH:mm',
          'DD/MM/YYYY',
          'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)' // <-- Wed Jun 25 2025 00:00:00 GMT-0600 (CST)
        ],
        true
      );

      // 4) Último recurso: parseo genérico (no estricto)
      if (!d.isValid()) d = dayjs(date);
    }
  }

  if (!d.isValid()) return '';

  if (subtractSixHours) d = d.subtract(hoursOffset, 'hour');

  const dateFmt = `DD${separator}MM${separator}YYYY`;
  const timeFmt = withSeconds ? 'HH:mm:ss' : 'HH:mm';

  return withTime ? d.format(`${dateFmt} ${timeFmt}`) : d.format(dateFmt);
};